export default "__VITE_ASSET__DFxPkBGX__"